import { ActionIcon, Box, Stack } from "@mantine/core";
import { IconArrowBarLeft, IconArrowBarRight } from "@tabler/icons-react";

const ListingHandle = ({
  isMinimized,
  hidden,
  onClick,
  hideButtons,
  allowMax,
  ...props
}) => {
  return (
    <Box
      mx={0}
      pos={"absolute"}
      top={0}
      right={0}
      h={"100%"}
      w={2}
      bg={"primary.1"}
      {...props}
    >
      {!hideButtons && (
        <Stack pos={"relative"} h={"100%"} align="center" justify="center">
          <ActionIcon.Group wrap="nowrap" gap={0}>
            {!hidden && (
              <ActionIcon
                onClick={() => onClick({ toRight: false })}
                color="primary.6"
                size={"sm"}
              >
                <IconArrowBarLeft />
              </ActionIcon>
            )}

            {(allowMax || isMinimized) && (
              <ActionIcon
                onClick={() => onClick({ toRight: true })}
                color="primary.6"
                size={"sm"}
              >
                <IconArrowBarRight />
              </ActionIcon>
            )}
          </ActionIcon.Group>
        </Stack>
      )}
    </Box>
  );
};

export default ListingHandle;
